import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

interface PhotoSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  onPublish: () => void;
  imageUrl: string;
  hidePublish?: boolean;
}

export default function PhotoSuccessDialog({ open, onClose, onPublish, imageUrl, hidePublish }: PhotoSuccessDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        dir="rtl"
        className="max-w-sm mx-auto p-6 gap-0 rounded-2xl border-none bg-card"
      >
        {/* תמונה עם אנימציית ניצוצות */}
        <div className="relative flex justify-center mb-6">
          {/* ניצוצות */}
          <span className="sparkle sparkle-1 motion-safe:animate-sparkle-pop" />
          <span className="sparkle sparkle-2 motion-safe:animate-sparkle-pop [animation-delay:120ms]" />
          <span className="sparkle sparkle-3 motion-safe:animate-sparkle-pop [animation-delay:240ms]" />
          <span className="sparkle sparkle-4 motion-safe:animate-sparkle-pop [animation-delay:60ms]" />
          <span className="sparkle sparkle-5 motion-safe:animate-sparkle-pop [animation-delay:180ms]" />

          <img
            src={imageUrl}
            alt="תמונה שצולמה"
            className="w-full max-h-72 object-cover rounded-xl motion-safe:animate-scale-in"
          />
        </div>

        <p className="text-center text-lg font-semibold text-foreground mb-1">
          כל הכבוד! 🎉
        </p>
        <p className="text-center text-sm text-muted-foreground mb-6">
          המשימה הושלמה בהצלחה
        </p>

        {/* כפתור פרסום לפיד — מוסתר בקורסים */}
        {!hidePublish && (
          <button
            onClick={onPublish}
            className="w-full text-center text-sm font-medium text-primary mb-3 py-2 active:underline"
            aria-label="פרסום לפיד"
          >
            פרסום לפיד
          </button>
        )}

        {/* כפתור אישור */}
        <button
          onClick={onClose}
          className="w-full rounded-xl bg-primary text-primary-foreground py-3 text-sm font-semibold"
          aria-label="אישור"
        >
          אישור
        </button>
      </DialogContent>
    </Dialog>
  );
}
